// extracted by mini-css-extract-plugin
module.exports = {"loading":"LoadingStyle_loading__2IIwr","centerPosition":"LoadingStyle_centerPosition__26XFF"};